import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { AlertService } from '../_services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from '../_services/user-profile.service';
import { User } from '../_models/user';
import { WelcomeService } from '../_services/welcome.service';

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  isPageLoaded = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    public authService: AuthService,
    private profileService: UserProfileService,
    private renderer: Renderer2,
    private translate: TranslateService,
    private welcomeService: WelcomeService
  ) {
    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];
    });
  }

  ngAfterViewInit(): void {
    const footerElement = document.getElementsByClassName('footer');
    Array.from(footerElement).forEach((el) => {
      this.renderer.removeClass(el, 'footer-static');
      this.renderer.addClass(el, 'fixed-bottom');
    });
  }

  ngOnInit() {
    this.welcomeService.setMustOpenWelcome(true);
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: false
    });
    // Remember Me
    if (localStorage.getItem('remember')) {
      this.renderer.removeClass(document.body, 'bg-full-screen-image');
      localStorage.removeItem('currentLayoutStyle');
      this.router.navigate(['/projects/project-list']);
    } else if (localStorage.getItem('currentUser')) {
      // Force logout on login if not remember me
      this.authService.doLogout();
      this.isPageLoaded = true;
    } else {
      this.isPageLoaded = true;
    }
    this.renderer.addClass(document.body, 'authentication-pages');
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  tryLogin() {
    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.loading = false;
      return;
    }
    const value = {
      email: this.f.email.value,
      password: this.f.password.value
    };
    this.authService.doLogin(value).then(
      async res => {
        if (this.loginForm.controls['rememberMe'] && this.loginForm.controls['rememberMe'].value) {
          localStorage.setItem('remember', 'true');
        } else {
          localStorage.removeItem('remember');
        }
        await this.setUserInStorage(res);
        localStorage.removeItem('currentLayoutStyle');
        let returnUrl = '/projects/project-list';
        if (this.returnUrl) {
          returnUrl = this.returnUrl;
        }
        this.router.navigate([returnUrl]);
        this.loading = false;
      },
      err => {
        this.submitted = false;
        this.loading = false;
        if (err.status == 401 || err.error.error == 'invalid_grant')
          this.alertService.error(this.translate.instant('login.invalidUserOrPassword'));
        else
          this.alertService.error(err.message);
      }
    );
  }

  async setUserInStorage(res) {
    let user: User = null;
    await this.authService.getUserInfo(res.access_token).then(
      inf => {
        user = inf;
        user.token = res;
        this.authService.saveCurrentUser(user);
      },
      err => {
        console.log(err);
      }
    )

    if(user !== null) {
       // Get user image
       let profileObj = null;
      await this.profileService.getUserProfile(user.sub).then(profile => {
        profileObj = profile;
      });

      await this.profileService.getUserImageURL(profileObj).then(url => {
        user.photo_url = url;
        this.authService.saveCurrentUser(user);
      });
    }
  }
}
